// extracted by css-extract-rspack-plugin
export default {"Schedule":"ldq5L","ControlGroup":"Sxu0H","TextInFirstColumn":"qUPNK","TextInSecondColumn":"jc0xE","CompactLabels":"MGafy","Horizontal":"_Jsc6","FullWidthSelects":"QyJhp"};